import { render, staticRenderFns } from "./Edenred.vue?vue&type=template&id=5afd11ae"
import script from "./Edenred.vue?vue&type=script&lang=ts"
export * from "./Edenred.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afd11ae')) {
      api.createRecord('5afd11ae', component.options)
    } else {
      api.reload('5afd11ae', component.options)
    }
    module.hot.accept("./Edenred.vue?vue&type=template&id=5afd11ae", function () {
      api.rerender('5afd11ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/Edenred.vue"
export default component.exports